import React, { useState, useEffect, useRef, useMemo } from "react";
import Overlay from "../../UILibrary/Overlay";
import PreviewPopup from "../../UILibrary/FilePreviewPopup/PreviewPopup";
import CompanyAvatar from "../../UILibrary/CompanyAvatar";
import { useSelector, useDispatch } from "react-redux";
import { sendMessage } from "../../../store/messagesSlice";
import { Dialog } from "@headlessui/react";
import { X } from "lucide-react";
const Messages = ({ selectedUser, setSelectedUser }) => {
  const dispatch = useDispatch();
  const outreach = useSelector((state) => state.messages);
  const [activeMessages, setActiveMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [bulkSubject, setBulkSubject] = useState("");
  const [importedFile, setImportedFile] = useState(null);
  const [isImported, setIsImported] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const [selectedTab, setSelectedTab] = useState("In network");
  const suppliers = useSelector((state) => state.suppliers.suppliers);

  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [selectedRecipients, setSelectedRecipients] = useState([]);

  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const MAX_LENGTH = 400;

  const [projectDetails, setProjectDetails] = useState({
    name: "",
    description: "",
    budget: 0,
    time: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSubjectErr, setSubjectErr] = useState(false);

  const filteredSuppliers = suppliers.filter((s) => {
    const fullName = `${s?.contact?.type?.[0]?.name?.firstName || ""} ${
      s?.contact?.type?.[0]?.name?.lastName || ""
    }`.toLowerCase();
    const company = s?.company?.name?.toLowerCase() || "";
    return (
      fullName.includes(searchTerm.toLowerCase()) ||
      company.includes(searchTerm.toLowerCase())
    );
  });

  const toggleRecipient = (supplier) => {
    setShowError(false);
    setSelectedRecipients((prev) => {
      const exists = prev.find((r) => r._id === supplier._id);
      return exists
        ? prev.filter((r) => r._id !== supplier._id)
        : [...prev, supplier];
    });
  };

  useEffect(() => {
    console.log("Updated selectedRecipients:", selectedRecipients);
  }, [selectedRecipients]);

  const [openFolders, setOpenFolders] = useState({});

  const [attachedFile, setAttachedFile] = useState(null);
  const [attachedImage, setAttachedImage] = useState(null);

  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const containerRef = useRef(null);
  const lastMessageRef = useRef(null);

  const handleAttachImgClick = () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = null;
      imageInputRef.current.click();
    }
  };

  const handleAttachFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAttachedImage(file);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setAttachedFile(file);
      setImportedFile(file);
      setIsImported(true);
    }
    e.target.value = "";
  };

  const toggleFolder = (subject) => {
    setOpenFolders((prev) => ({
      ...prev,
      [subject]: !prev[subject],
    }));
  };

  const EmojiPicker = ({ onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const emojiCategories = [
      "😀",
      "😁",
      "😂",
      "🤣",
      "😊",
      "😎",
      "😍",
      "😒",
      "😭",
      "😡",
      "👍",
      "👎",
      "👏",
      "🙌",
      "🙏",
      "🤞",
      "👋",
      "🤝",
      "✌️",
      "❤️",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "💔",
      "💕",
      "💖",
      "🎉",
      "🎊",
      "🎁",
      "🎂",
      "🍾",
      "🥂",
      "✨",
    ];

    const handleClick = (emoji) => {
      if (onSelect) onSelect(emoji);
      setIsOpen(false);
    };

    return (
      <div className="inline-block relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <g clip-path="url(#clip0_339_22523)">
            <path
              d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM14.8 13.857C14.8933 13.7629 15.0044 13.6882 15.1268 13.6374C15.2492 13.5866 15.3804 13.5606 15.513 13.561C15.6455 13.5614 15.7766 13.5881 15.8987 13.6396C16.0208 13.6911 16.1315 13.7663 16.2243 13.8609C16.317 13.9556 16.3901 14.0677 16.4391 14.1908C16.4882 14.3139 16.5123 14.4455 16.5101 14.578C16.5078 14.7105 16.4792 14.8413 16.426 14.9626C16.3728 15.084 16.2959 15.1936 16.2 15.285C15.0794 16.3858 13.5708 17.0018 12 17C10.4292 17.0018 8.92064 16.3858 7.8 15.285C7.61503 15.0984 7.51093 14.8465 7.5102 14.5838C7.50948 14.321 7.61219 14.0685 7.79613 13.8809C7.98006 13.6933 8.23045 13.5856 8.49316 13.5811C8.75586 13.5767 9.00977 13.6758 9.2 13.857C9.94682 14.5912 10.9527 15.0018 12 15C13.09 15 14.077 14.565 14.8 13.857ZM8.5 8C8.89782 8 9.27936 8.15804 9.56066 8.43934C9.84196 8.72064 10 9.10218 10 9.5C10 9.89782 9.84196 10.2794 9.56066 10.5607C9.27936 10.842 8.89782 11 8.5 11C8.10218 11 7.72064 10.842 7.43934 10.5607C7.15804 10.2794 7 9.89782 7 9.5C7 9.10218 7.15804 8.72064 7.43934 8.43934C7.72064 8.15804 8.10218 8 8.5 8ZM15.5 8C15.8978 8 16.2794 8.15804 16.5607 8.43934C16.842 8.72064 17 9.10218 17 9.5C17 9.89782 16.842 10.2794 16.5607 10.5607C16.2794 10.842 15.8978 11 15.5 11C15.1022 11 14.7206 10.842 14.4393 10.5607C14.158 10.2794 14 9.89782 14 9.5C14 9.10218 14.158 8.72064 14.4393 8.43934C14.7206 8.15804 15.1022 8 15.5 8Z"
              fill="#7B7B7B"
            />
          </g>
          <defs>
            <clipPath id="clip0_339_22523">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {isOpen && (
          <div className="absolute bottom-full left-0 mb-2 w-64 max-h-60 overflow-y-auto bg-white shadow-lg border rounded-lg z-50 p-3">
            <div className="flex flex-wrap gap-2">
              {emojiCategories.map((emoji) => (
                <button
                  key={emoji}
                  onClick={() => handleClick(emoji)}
                  className="text-xl hover:scale-125 transition-transform"
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleQuoteRequestedCompleted = () => {
    setQuoteRequsted(false);
    setProjectDetails({
      name: "",
      description: "",
      budget: 0,
      time: "",
    });
  };

  const handleCancel = () => {
    setQuoteRequsted(false);
    setProjectDetails({
      name: "",
      description: "",
      budget: 0,
      time: "",
    });
  };

  const divFlexRow = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };

  const [isQuoteRequested, setQuoteRequsted] = useState(false);

  const handleRequestQuote = () => {
    setQuoteRequsted(true);
  };
  const handleSendMessage = () => {
    if (!selectedUser) return;
    if (!messageInput && !attachedFile && !attachedImage) return;
    setShowError(false);

    const newMessage = {
      timestamp: new Date().toISOString(),
      type: "received",
      content: {
        text: messageInput || "",
        file: attachedFile
          ? {
              name: attachedFile.name,
              type: attachedFile.type,
              url: URL.createObjectURL(attachedFile),
            }
          : null,
        image: attachedImage
          ? {
              name: attachedImage.name,
              type: attachedImage.type,
              url: URL.createObjectURL(attachedImage),
            }
          : null,
      },
    };

    if (selectedUser.isBulk) {
      dispatch(
        sendMessage({
          subject: selectedUser.subject,
          supplierId: selectedUser._id,
          supplier: selectedUser,
          message: newMessage,
        })
      );
    } else {
      dispatch(
        sendMessage({
          supplierId: selectedUser._id,
          supplier: selectedUser,
          message: newMessage,
        })
      );
    }
    setStep(3);
    setMessageInput("");
    setAttachedFile(null);
    setImportedFile(null);
    setAttachedImage(null);
    setSelectedEmoji(null);
  };

  const handleSendMessageToNewUser = () => {
    const selectedUser = selectedRecipients[0];
    if (!selectedUser) return;
    if (!messageInput && !attachedFile && !attachedImage) return;
    setShowError(false);

    const newMessage = {
      timestamp: new Date().toISOString(),
      type: "sent",
      content: {
        text: messageInput || "",
        file: attachedFile
          ? {
              name: attachedFile.name,
              type: attachedFile.type,
              url: URL.createObjectURL(attachedFile),
            }
          : null,
        image: attachedImage
          ? {
              name: attachedImage.name,
              type: attachedImage.type,
              url: URL.createObjectURL(attachedImage),
            }
          : null,
      },
    };

    console.log(selectedUser, "selected");
    dispatch(
      sendMessage({
        supplierId: selectedUser._id,
        supplier: selectedUser,
        message: newMessage,
      })
    );

    setStep(3);
    setMessageInput("");
    setAttachedFile(null);
    setImportedFile(null);
    setAttachedImage(null);
    setSelectedEmoji(null);
  };
  const handleSendBulkMessage = () => {
    if (!messageInput && !attachedFile && !attachedImage) return;

    const suppliersPayload = selectedRecipients.map((s) => ({
      supplierId: s._id,
      supplier: s,
    }));

    dispatch(
      sendMessage({
        suppliers: suppliersPayload,
        subject: bulkSubject,
        message: {
          username: "You",
          type: "sent",
          content: {
        text: messageInput || "",
        file: attachedFile
          ? {
              name: attachedFile.name,
              type: attachedFile.type,
              url: URL.createObjectURL(attachedFile),
            }
          : null,
        image: attachedImage
          ? {
              name: attachedImage.name,
              type: attachedImage.type,
              url: URL.createObjectURL(attachedImage),
            }
          : null,
      },
    
          timestamp: new Date().toISOString(),
        },
      })
    );
    setShowError(false);
    setStep(3);
    setBulkSubject("");
    setMessageInput('');
    setAttachedFile(null);
    setImportedFile(null);
    setAttachedImage(null);
    setSelectedEmoji(null);
  };

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const closePreview = () => {
    setShowPreviewPopup(false);
  };

  const suppliersList = Object.values(outreach.outreachSuppliers).map(
    (item, i) => {
      const { supplier, messages } = item;
      const isUserActive = supplier?.status === "Active";

      const handleClick = () => {
        setSelectedUser({
          ...supplier,
          isBulk: false,
        });
      };

      return (
        <div
          key={`${supplier?._id || i}`}
          className={`cursor-pointer mr-3 mb-8 rounded-xl p-2 ${
            selectedUser?._id === supplier?._id ? "bg-[#F2F2F2] p-2" : ""
          }`}
          onClick={handleClick}
        >
          <div>
            <div className="integration-list-content">
              <div className="integration-list-info">
                <div className="relative">
                  <div className="mr-2">
                    <CompanyAvatar
                      companyName={supplier?.contact?.type[0]?.name?.firstName}
                      size="41px"
                    />
                  </div>

                  {isUserActive && <span className="status-dot"></span>}
                </div>
                <div className="talent-overview">
                  <p className="messages-list-subtitle">
                    {supplier?.contact?.type[0]?.name?.firstName} &nbsp;
                    {supplier?.contact?.type[0]?.name?.lastName}
                  </p>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <p style={{ color: "#7B7B7B", fontSize: "12px" }}>
                      {supplier?.contact?.type[0]?.Salutation}
                    </p>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ color: "#7B7B7B", fontSize: "12px" }}>2h ago</p>
              </div>
            </div>
          </div>
          <div className="messages-container">
            <p className="text-xs text-gray-500 ml-[45px] mr-[45px] text-left">
              {messages && messages.length > 0
                ? messages[messages.length - 1].content?.text || ""
                : ""}
            </p>
            {supplier?.unreadMessages > 0 && (
              <p className="flex justify-center items-center p-[10px] rounded-[26px] bg-red-600 mt-3 text-white w-[8px] h-[14px]">
                {supplier?.unreadMessages}
              </p>
            )}
          </div>
        </div>
      );
    }
  );

  const userMessages = useMemo(() => {
    if (!selectedUser) return [];

    if (selectedUser.isBulk) {
      return (
        outreach.bulkOutreach?.[selectedUser.subject]?.suppliers?.[
          selectedUser._id
        ]?.messages || []
      );
    } else {
      return outreach.outreachSuppliers?.[selectedUser._id]?.messages || [];
    }
  }, [selectedUser, outreach]);

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [userMessages]);

  const userDetails = selectedUser && (
    <div className="bg-white flex flex-col ml-2 w-full ">
      <div
        className="user-details-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "10px" }}>
            <CompanyAvatar
              companyName={selectedUser.contact.type[0].name.firstName}
              size="41px"
            />
          </div>
          <div className="user-details-info">
            <div style={{ display: "flex", flexDirection: "row" }}>
              <p className="supplier-profile-title">
                {selectedUser.contact.type[0].name.firstName} &nbsp;
                {selectedUser.contact.type[0].name.lastName}
              </p>
              {selectedUser?.status === "Active" && (
                <p className="text-[#8BBBE6] font-normal text-sm rounded bg-[rgba(14,128,128,0.04)] px-[10px] py-[5px] flex justify-center items-center ml-[20px]">
                  {selectedUser?.status}
                </p>
              )}
            </div>

            <p className="supplier-profile-subtitle">
              {selectedUser.contact.type[0].Salutation}
            </p>
            <p
              className="supplier-profile-subtitle"
              style={{ fontSize: "16px", marginTop: "8px" }}
            >
              {selectedUser.contact.type[0].email}
            </p>
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="hire-btn mr-3 bg-[#EAF524]"
            onClick={handleRequestQuote}
          >
            Request a quote
          </button>
        </div>
      </div>

      <div
        ref={containerRef}
        className="overflow-y-auto flex-1 p-2"
        style={{ maxHeight: "480px" }}
      >
        {userMessages.map((msg, index) => {
          const dateObject = new Date(msg.timestamp);
          const time = dateObject.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          });
          const date = dateObject.toLocaleDateString("en-US", {
            weekday: "short",
            day: "2-digit",
            month: "short",
          });

          const showDateDivider =
            index === 0 ||
            new Date(userMessages[index - 1].timestamp).getDate() !==
              dateObject.getDate();

          const { text, file, image } = msg.content;

          return (
            <div
              key={index}
              ref={index === userMessages.length - 1 ? lastMessageRef : null} // attach ref to last message
              className={`flex flex-col ${
                msg.type === "sent" ? "items-end" : "items-start"
              } mr-6 mb-14 ${showDateDivider ? "mt-8" : ""}`}
            >
              {showDateDivider && (
                <p className="text-center text-xs w-[100px] px-4 py-2 rounded-[15px] bg-[#F7F7F7] mx-auto mb-2">
                  {date}
                </p>
              )}
              <div
                className={
                  msg.type === "sent" ? "user-message" : "receiver-message"
                }
              >
                {msg.type !== "sent" && (
                  <p className="text-xs text-[#1C1C1C] mb-4">{msg.username}</p>
                )}

                {text && <p className="text-left mb-2">{text}</p>}

                {image && image.url && (
                  <img
                    src={image.url}
                    alt={image.name || "attached"}
                    className="max-w-[200px] rounded-md mb-2"
                  />
                )}

                {file && file.url && (
                  <div className="flex flex-start mb-2">
                    <a
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline text-blue-600 hover:text-blue-800 text-left"
                    >
                      {file.name}
                    </a>
                  </div>
                )}

                <p className="text-right text-xs">{time}</p>
              </div>
            </div>
          );
        })}
      </div>
      {/* <div className="mb-2 ml-8 gap-2 flex items-center w-[95%] py-2 px-4  bg-[#F4F4F4] rounded-full">
       */}
      <div className="mb-2 ml-8 gap-2 flex items-center w-[95%] py-2 px-4 bg-[#F4F4F4] rounded-full">
        <input
          type="file"
          accept="image/*"
          ref={imageInputRef}
          className="hidden"
          onChange={handleImageChange}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="flex items-center justify-center cursor-pointer"
          onClick={handleAttachImgClick}
        >
          <path
            d="M7.86716 14.3868L13.7007 8.55333C14.4327 7.82133 15.4872 7.68858 16.2199 8.42058C16.9519 9.15258 16.8199 10.2078 16.0872 10.9398L9.98816 17.0388C8.92766 18.0993 6.80591 18.0993 5.48066 16.7733C4.15466 15.4473 4.15466 13.3263 5.21516 12.2658L11.3142 6.16683C12.2312 5.26647 13.4667 4.76465 14.7519 4.77056C16.037 4.77646 17.2679 5.28961 18.1766 6.19836C19.0854 7.10711 19.5985 8.33795 19.6044 9.62311C19.6103 10.9083 19.1085 12.1438 18.2082 13.0608L14.7612 16.5078"
            stroke="#7B7B7B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <EmojiPicker
          onSelect={(emoji) => setMessageInput((prev) => prev + emoji)}
        />

        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileChange}
        />

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="flex items-center justify-center cursor-pointer"
          onClick={handleAttachFileClick}
        >
          <path
            d="M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z"
            fill="#7B7B7B"
          />
        </svg>

        {isImported && importedFile && (
          <span className="ml-2 text-sm text-gray-600">
            {importedFile.name}
          </span>
        )}

        <textarea
          placeholder="Type message"
          rows="1"
          className="flex-1 text-[#929292] resize-none p-2 border bg-[#F4F4F4] rounded-md focus:outline-none"
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
        />
        {attachedImage && (
          <div className="m-1 relative w-10 h-10">
            <img
              src={
                attachedImage instanceof File
                  ? URL.createObjectURL(attachedImage)
                  : attachedImage
              }
              alt="preview"
              className="w-full h-full object-cover rounded-md"
            />
            <button
              type="button"
              className="absolute -top-3 -right-2 p-1 text-gray-400"
              onClick={() => setAttachedImage(null)}
            >
              ✕
            </button>
          </div>
        )}

        <button
          type="submit"
          onClick={handleSendMessage}
          className="flex items-center justify-center w-10 h-10 rounded-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.53563 8.89722C4.18896 5.78522 7.39296 3.49989 10.2236 4.84122L26.149 12.3852C29.1996 13.8292 29.1996 18.1706 26.149 19.6146L10.2236 27.1599C7.39296 28.5012 4.19029 26.2159 4.53563 23.1039L5.17563 17.3332H15.9996C16.3532 17.3332 16.6924 17.1927 16.9424 16.9427C17.1925 16.6926 17.333 16.3535 17.333 15.9999C17.333 15.6463 17.1925 15.3071 16.9424 15.0571C16.6924 14.807 16.3532 14.6666 15.9996 14.6666H5.17696L4.53563 8.89722Z"
              fill="#0088FF"
            />
          </svg>
        </button>
      </div>

      {isQuoteRequested && (
        <>
          <Overlay />
          <div className="edit-budget-container absolute left-1/2 top-[10%] transform -translate-x-1/2 z-[1100]">
            <form>
              <div style={divFlexRow}>
                <span
                  style={{
                    fontWeight: 600,
                    textAlign: "left",
                    fontSize: "20px",
                  }}
                >
                  Request a quote
                </span>
              </div>
              <div className="single-input" style={{ margin: "40px 0 20px 0" }}>
                <label className="block text-[#1D2639] text-base text-start font-normal mb-2">
                  Project name
                </label>
                <input
                  type="text"
                  placeholder="Project name"
                  className="custom-edit-profile-input"
                  value={projectDetails.name}
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      name: e.target.value,
                    })
                  }
                />
              </div>

              <div className="single-input" style={{ margin: "40px 0 20px 0" }}>
                <label className="block text-[#1D2639] text-base text-start font-normal mb-2">
                  Give a detailed description of the project
                </label>
                <textarea
                  className="w-full h-24 p-3 bg-[#F9F9F9] rounded-lg border-2 border-gray-300"
                  value={projectDetails.description}
                  placeholder="Description"
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      description: e.target.value,
                    })
                  }
                />
              </div>

              <div className="single-input" style={{ margin: "40px 0 20px 0" }}>
                <label className="block text-[#1D2639] text-base text-start font-normal mb-2">
                  Budget
                </label>
                <input
                  type="text"
                  placeholder="Project name"
                  className="custom-edit-profile-input"
                  value={projectDetails.budget}
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      budget: e.target.value,
                    })
                  }
                />
              </div>

              <div className="single-input" style={{ margin: "40px 0 20px 0" }}>
                <label className="block text-[#1D2639] text-base text-start font-normal mb-2">
                  Timeline
                </label>
                <input
                  type="text"
                  placeholder="Weeks"
                  className="custom-edit-profile-input"
                  value={projectDetails.time}
                  onChange={(e) =>
                    setProjectDetails({
                      ...projectDetails,
                      time: e.target.value,
                    })
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "20px",
                  position: "absolute",
                  bottom: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <button
                  className="flex w-[432px] h-[56px] p-5 justify-center items-center rounded-[13px] bg-[#EAF524]"
                  onClick={() => handleQuoteRequestedCompleted()}
                >
                  Save
                </button>
                <button
                  onClick={() => handleCancel()}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#7E7E7E",
                    border: "none",
                    background: "none",
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </>
      )}

      {showPreviewPopup && (
        <>
          <Overlay />
          <PreviewPopup file={previewFile} onClose={closePreview} />
        </>
      )}
    </div>
  );

  function openThread(subject, supplierId) {
    if (subject) {
      setActiveMessages(
        outreach.bulkOutreach[subject].suppliers[supplierId].messages
      );
    } else {
      setActiveMessages(outreach.outreachSuppliers[supplierId].messages);
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div className="messages-main-container">
        <div>
          <button className="flex h-10 px-2 py-1 flex-row justify-start items-center text-[#A8A8A8] gap-2 rounded-lg bg-[#EDEDED] self-stretch w-full mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clip-path="url(#clip0_354_366)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.74972 1.6665C7.62022 1.6666 6.50711 1.93681 5.50327 2.45458C4.49943 2.97236 3.63397 3.72268 2.97909 4.64297C2.32421 5.56325 1.8989 6.62679 1.73865 7.74487C1.5784 8.86295 1.68785 10.0031 2.05787 11.0703C2.4279 12.1375 3.04776 13.1007 3.86575 13.8796C4.68375 14.6585 5.67614 15.2305 6.76015 15.5478C7.84416 15.8652 8.98834 15.9187 10.0972 15.7039C11.2061 15.4892 12.2476 15.0123 13.1347 14.3132L16.1781 17.3565C16.3352 17.5083 16.5457 17.5923 16.7642 17.5904C16.9827 17.5885 17.1917 17.5009 17.3462 17.3464C17.5007 17.1918 17.5884 16.9828 17.5903 16.7643C17.5922 16.5458 17.5082 16.3353 17.3564 16.1782L14.3131 13.1348C15.1364 12.0904 15.649 10.8352 15.7923 9.51294C15.9356 8.19071 15.7037 6.85485 15.1232 5.65825C14.5428 4.46164 13.6371 3.45263 12.51 2.7467C11.3828 2.04076 10.0797 1.66641 8.74972 1.6665ZM3.33306 8.74984C3.33306 7.31325 3.90374 5.9355 4.91956 4.91968C5.93538 3.90385 7.31313 3.33317 8.74972 3.33317C10.1863 3.33317 11.5641 3.90385 12.5799 4.91968C13.5957 5.9355 14.1664 7.31325 14.1664 8.74984C14.1664 10.1864 13.5957 11.5642 12.5799 12.58C11.5641 13.5958 10.1863 14.1665 8.74972 14.1665C7.31313 14.1665 5.93538 13.5958 4.91956 12.58C3.90374 11.5642 3.33306 10.1864 3.33306 8.74984Z"
                  fill="#7B7B7B"
                />
              </g>
              <defs>
                <clipPath id="clip0_354_366">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Search
          </button>

          <div className="flex flex-row justify-between mb-10">
            <span
              onClick={() => handleTabClick("In network")}
              className={`flex flex-row items-center text-[#1D2739] cursor-pointer ${
                selectedTab === "In network"
                  ? "text-black rounded-[1px] border-b-2 border-[#08F]"
                  : "text-[#7B7B7B]"
              }`}
            >
              In network
            </span>
            <div
              className="relative flex justify-end items-center cursor-pointer group"
              onClick={() => setIsOpen(true)}
            >
              {/* Tooltip */}
              <div className="flex flex-row justify-start items-center absolute -bottom-9 right-0 bg-white border text-[#7B7B7B] text-xs rounded-md px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="mr-2"
                >
                  <path
                    d="M7.25009 8C7.25009 8.19891 7.32911 8.38968 7.46976 8.53033C7.61041 8.67098 7.80118 8.75 8.00009 8.75C8.199 8.75 8.38977 8.67098 8.53042 8.53033C8.67107 8.38968 8.75009 8.19891 8.75009 8C8.75009 7.80109 8.67107 7.61032 8.53042 7.46967C8.38977 7.32902 8.199 7.25 8.00009 7.25C7.80118 7.25 7.61041 7.32902 7.46976 7.46967C7.32911 7.61032 7.25009 7.80109 7.25009 8ZM10.3751 8C10.3751 8.19891 10.4541 8.38968 10.5948 8.53033C10.7354 8.67098 10.9262 8.75 11.1251 8.75C11.324 8.75 11.5148 8.67098 11.6554 8.53033C11.7961 8.38968 11.8751 8.19891 11.8751 8C11.8751 7.80109 11.7961 7.61032 11.6554 7.46967C11.5148 7.32902 11.324 7.25 11.1251 7.25C10.9262 7.25 10.7354 7.32902 10.5948 7.46967C10.4541 7.61032 10.3751 7.80109 10.3751 8ZM4.12509 8C4.12509 8.19891 4.20411 8.38968 4.34476 8.53033C4.48541 8.67098 4.67618 8.75 4.87509 8.75C5.074 8.75 5.26477 8.67098 5.40542 8.53033C5.54607 8.38968 5.62509 8.19891 5.62509 8C5.62509 7.80109 5.54607 7.61032 5.40542 7.46967C5.26477 7.32902 5.074 7.25 4.87509 7.25C4.67618 7.25 4.48541 7.32902 4.34476 7.46967C4.20411 7.61032 4.12509 7.80109 4.12509 8ZM14.4563 5.2875C14.1032 4.44844 13.597 3.69531 12.9517 3.04844C12.3108 2.40532 11.5501 1.89411 10.7126 1.54375C9.85321 1.18281 8.94071 1 8.00009 1H7.96884C7.02196 1.00469 6.10478 1.19219 5.24228 1.56094C4.41191 1.91489 3.65833 2.42701 3.02353 3.06875C2.38446 3.71406 1.8829 4.46406 1.53603 5.3C1.17665 6.16563 0.995401 7.08594 1.00009 8.03281C1.00539 9.11792 1.26211 10.187 1.75009 11.1562V13.5312C1.75009 13.7219 1.82581 13.9047 1.96061 14.0395C2.0954 14.1743 2.27821 14.25 2.46884 14.25H4.8454C5.81461 14.738 6.88373 14.9947 7.96884 15H8.00165C8.93759 15 9.8454 14.8188 10.7001 14.4641C11.5334 14.1179 12.2913 13.6126 12.9313 12.9766C13.5767 12.3375 14.0845 11.5906 14.4392 10.7578C14.8079 9.89531 14.9954 8.97812 15.0001 8.03125C15.0048 7.07969 14.8204 6.15625 14.4563 5.2875ZM12.0954 12.1313C11.0001 13.2156 9.54696 13.8125 8.00009 13.8125H7.97353C7.03134 13.8078 6.0954 13.5734 5.26884 13.1328L5.13759 13.0625H2.93759V10.8625L2.86728 10.7312C2.42665 9.90469 2.19228 8.96875 2.18759 8.02656C2.18134 6.46875 2.77665 5.00625 3.86884 3.90469C4.95946 2.80312 6.41728 2.19375 7.97509 2.1875H8.00165C8.7829 2.1875 9.54071 2.33906 10.2548 2.63906C10.9517 2.93125 11.5767 3.35156 12.1142 3.88906C12.6501 4.425 13.072 5.05156 13.3642 5.74844C13.6673 6.47031 13.8188 7.23594 13.8157 8.02656C13.8063 9.58281 13.1954 11.0406 12.0954 12.1313Z"
                    fill="#7B7B7B"
                  />
                </svg>
                <span className="text-xs px-2 py-1 whitespace-nowrap">
                  Create new message
                </span>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
              >
                <path
                  d="M10 3.50023H5.8C4.11984 3.50023 3.27976 3.50023 2.63803 3.82721C2.07354 4.11483 1.6146 4.57377 1.32698 5.13826C1 5.77999 1 6.62007 1 8.30023V16.7002C1 18.3804 1 19.2205 1.32698 19.8622C1.6146 20.4267 2.07354 20.8856 2.63803 21.1732C3.27976 21.5002 4.11984 21.5002 5.8 21.5002H14.2C15.8802 21.5002 16.7202 21.5002 17.362 21.1732C17.9265 20.8856 18.3854 20.4267 18.673 19.8622C19 19.2205 19 18.3804 19 16.7002V12.5002M6.99997 15.5002H8.67452C9.1637 15.5002 9.40829 15.5002 9.63846 15.445C9.84254 15.396 10.0376 15.3152 10.2166 15.2055C10.4184 15.0818 10.5914 14.9089 10.9373 14.563L20.5 5.00023C21.3284 4.1718 21.3284 2.82865 20.5 2.00023C19.6716 1.1718 18.3284 1.1718 17.5 2.00022L7.93723 11.563C7.59133 11.9089 7.41838 12.0818 7.29469 12.2837C7.18504 12.4626 7.10423 12.6577 7.05523 12.8618C6.99997 13.0919 6.99997 13.3365 6.99997 13.8257V15.5002Z"
                  stroke="black"
                  stroke-opacity="0.8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="w-[313px] mb-6">
          <div className="w-[313px] mb-6">
            {selectedTab === "In network" && (
              <>
                {Object.values(outreach.bulkOutreach || {}).map((bulk) => {
                  const firstMessage = Object.values(bulk.suppliers)[0]
                    ?.messages?.[0];

                  return (
                    <div key={bulk.subject} className="mb-4 pb-2">
                      <div
                        className="flex justify-between items-start cursor-pointer"
                        onClick={() => toggleFolder(bulk.subject)}
                      >
                        <div>
                          <div className="flex flex-row items-center justify-between">
                            <div className="flex flex-row items-center">
                              <div className="rounded-full bg-[#D1D1D1] p-2 flex justify-center items-center mr-4">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22"
                                  height="22"
                                  viewBox="0 0 22 22"
                                  fill="none"
                                >
                                  <path
                                    d="M19.5898 7.38465C19.1223 6.26909 18.4423 5.25512 17.5877 4.39924C16.7356 3.54188 15.7234 2.86023 14.6085 2.39299C13.4665 1.91201 12.2394 1.66546 11.0002 1.66799H10.9585C9.6981 1.67424 8.47935 1.92424 7.33143 2.4159C6.22617 2.88795 5.22346 3.57081 4.37935 4.42632C3.53296 5.28027 2.86075 6.2907 2.40018 7.40132C1.9221 8.55624 1.67984 9.79513 1.68768 11.0451C1.69393 12.4909 2.03977 13.9263 2.6856 15.2097V18.3763C2.6856 18.9055 3.11477 19.3347 3.64185 19.3347H6.80435C8.09367 19.9853 9.51645 20.3276 10.9606 20.3347H11.0044C12.2502 20.3347 13.4564 20.093 14.5939 19.6201C15.7031 19.1584 16.7116 18.4847 17.5627 17.6367C18.421 16.7847 19.096 15.7888 19.5689 14.6784C20.0585 13.5284 20.3085 12.3055 20.3148 11.043C20.3189 9.77424 20.0731 8.54299 19.5898 7.38465ZM6.84185 12.0013C6.29185 12.0013 5.84393 11.5534 5.84393 11.0013C5.84393 10.4492 6.29185 10.0013 6.84185 10.0013C7.39185 10.0013 7.83977 10.4492 7.83977 11.0013C7.83977 11.5534 7.39393 12.0013 6.84185 12.0013ZM11.0002 12.0013C10.4502 12.0013 10.0023 11.5534 10.0023 11.0013C10.0023 10.4492 10.4502 10.0013 11.0002 10.0013C11.5502 10.0013 11.9981 10.4492 11.9981 11.0013C11.9981 11.5534 11.5502 12.0013 11.0002 12.0013ZM15.1585 12.0013C14.6085 12.0013 14.1606 11.5534 14.1606 11.0013C14.1606 10.4492 14.6085 10.0013 15.1585 10.0013C15.7085 10.0013 16.1564 10.4492 16.1564 11.0013C16.1564 11.5534 15.7085 12.0013 15.1585 12.0013Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                              <div className="font-semibold text-gray-800">
                                {bulk.subject}
                              </div>
                            </div>
                            <div className="ml-6">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="11"
                                viewBox="0 0 10 11"
                                fill="none"
                              >
                                <path
                                  d="M8.125 3.9375L5 7.0625L1.875 3.9375"
                                  stroke="#1D2739"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="text-sm text-gray-500 truncate max-w-xs">
                            {firstMessage?.content?.text || ""}
                          </div>
                        </div>
                        <div className="text-xs text-gray-400">
                          {new Date(bulk.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </div>

                      {openFolders[bulk.subject] && (
                        <div
                          className="mt-4 mb-4 ml-4 max-h-40 overflow-y-auto border-l-2 border-gray-300 pl-2 scrollbar-hide"
                          style={{
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                          }}
                        >
                          {Object.values(bulk.suppliers).map(({ supplier }) => {
                            const firstName =
                              supplier?.contact?.type?.[0]?.name?.firstName;
                            const lastName =
                              supplier?.contact?.type?.[0]?.name?.lastName;
                            const companyName = supplier?.company?.name;

                            return (
                              <div
                                key={supplier?._id}
                                onClick={() => {
                                  openThread(bulk.subject, supplier?._id);
                                  setSelectedUser({
                                    ...supplier,
                                    isBulk: true,
                                    subject: bulk.subject,
                                  });
                                }}
                                className={`cursor-pointer mt-1 flex items-start p-2 rounded-xl gap-6
            ${
              selectedUser?._id === supplier?._id &&
              selectedUser?.subject === bulk.subject
                ? "bg-[#F2F2F2]"
                : ""
            }`}
                              >
                                <CompanyAvatar
                                  companyName={firstName}
                                  size="32px"
                                />
                                <div className="flex flex-col justify-center">
                                  <span className="font-medium text-sm text-left">
                                    {firstName} {lastName}
                                  </span>
                                  <span className="text-xs text-gray-500 text-left">
                                    {companyName}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}

                {suppliersList}
              </>
            )}
          </div>
        </div>
      </div>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative"
        style={{ zIndex: 10000 }}
      >
        <div
          className="fixed inset-0 bg-black/30 backdrop-blur-sm"
          aria-hidden="true"
        />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-[658px] rounded-2xl bg-white p-12 shadow-lg">
            {step !== 3 ? (
              <Dialog.Title
                as="h2"
                className="text-2xl font-semibold mb-4 flex flex-row justify-start items-center"
              >
                <div className="rounded bg-[#D1D1D1] p-3 mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M19.5898 7.38075C19.1223 6.26518 18.4423 5.25121 17.5877 4.39533C16.7356 3.53798 15.7234 2.85633 14.6085 2.38908C13.4665 1.9081 12.2394 1.66155 11.0002 1.66408H10.9585C9.6981 1.67033 8.47935 1.92033 7.33143 2.412C6.22617 2.88404 5.22346 3.5669 4.37935 4.42241C3.53296 5.27636 2.86075 6.28679 2.40018 7.39741C1.9221 8.55234 1.67984 9.79122 1.68768 11.0412C1.69393 12.487 2.03977 13.9224 2.6856 15.2057V18.3724C2.6856 18.9016 3.11477 19.3307 3.64185 19.3307H6.80435C8.09367 19.9814 9.51645 20.3237 10.9606 20.3307H11.0044C12.2502 20.3307 13.4564 20.0891 14.5939 19.6162C15.7031 19.1545 16.7116 18.4808 17.5627 17.6328C18.421 16.7807 19.096 15.7849 19.5689 14.6745C20.0585 13.5245 20.3085 12.3016 20.3148 11.0391C20.3189 9.77033 20.0731 8.53908 19.5898 7.38075ZM6.84185 11.9974C6.29185 11.9974 5.84393 11.5495 5.84393 10.9974C5.84393 10.4453 6.29185 9.99741 6.84185 9.99741C7.39185 9.99741 7.83977 10.4453 7.83977 10.9974C7.83977 11.5495 7.39393 11.9974 6.84185 11.9974ZM11.0002 11.9974C10.4502 11.9974 10.0023 11.5495 10.0023 10.9974C10.0023 10.4453 10.4502 9.99741 11.0002 9.99741C11.5502 9.99741 11.9981 10.4453 11.9981 10.9974C11.9981 11.5495 11.5502 11.9974 11.0002 11.9974ZM15.1585 11.9974C14.6085 11.9974 14.1606 11.5495 14.1606 10.9974C14.1606 10.4453 14.6085 9.99741 15.1585 9.99741C15.7085 9.99741 16.1564 10.4453 16.1564 10.9974C16.1564 11.5495 15.7085 11.9974 15.1585 11.9974Z"
                      fill="white"
                    />
                  </svg>
                </div>
                Create New Message
              </Dialog.Title>
            ) : (
              <Dialog.Title
                as="h2"
                className="font-semibold mb-4 flex flex-col justify-center items-center text-base"
              >
                <div className="inline-flex items-center justify-center bg-[#D1D1D1] rounded mr-4 p-3 w-12 mt-16 mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M19.5898 7.38075C19.1223 6.26518 18.4423 5.25121 17.5877 4.39533C16.7356 3.53798 15.7234 2.85633 14.6085 2.38908C13.4665 1.9081 12.2394 1.66155 11.0002 1.66408H10.9585C9.6981 1.67033 8.47935 1.92033 7.33143 2.412C6.22617 2.88404 5.22346 3.5669 4.37935 4.42241C3.53296 5.27636 2.86075 6.28679 2.40018 7.39741C1.9221 8.55234 1.67984 9.79122 1.68768 11.0412C1.69393 12.487 2.03977 13.9224 2.6856 15.2057V18.3724C2.6856 18.9016 3.11477 19.3307 3.64185 19.3307H6.80435C8.09367 19.9814 9.51645 20.3237 10.9606 20.3307H11.0044C12.2502 20.3307 13.4564 20.0891 14.5939 19.6162C15.7031 19.1545 16.7116 18.4808 17.5627 17.6328C18.421 16.7807 19.096 15.7849 19.5689 14.6745C20.0585 13.5245 20.3085 12.3016 20.3148 11.0391C20.3189 9.77033 20.0731 8.53908 19.5898 7.38075ZM6.84185 11.9974C6.29185 11.9974 5.84393 11.5495 5.84393 10.9974C5.84393 10.4453 6.29185 9.99741 6.84185 9.99741C7.39185 9.99741 7.83977 10.4453 7.83977 10.9974C7.83977 11.5495 7.39393 11.9974 6.84185 11.9974ZM11.0002 11.9974C10.4502 11.9974 10.0023 11.5495 10.0023 10.9974C10.0023 10.4453 10.4502 9.99741 11.0002 9.99741C11.5502 9.99741 11.9981 10.4453 11.9981 10.9974C11.9981 11.5495 11.5502 11.9974 11.0002 11.9974ZM15.1585 11.9974C14.6085 11.9974 14.1606 11.5495 14.1606 10.9974C14.1606 10.4453 14.6085 9.99741 15.1585 9.99741C15.7085 9.99741 16.1564 10.4453 16.1564 10.9974C16.1564 11.5495 15.7085 11.9974 15.1585 11.9974Z"
                      fill="white"
                    />
                  </svg>
                </div>
                Message sent successfully to supplier(s).
              </Dialog.Title>
            )}

            {step === 1 && (
              <>
                <label className="text-base font-medium text-[#1D2739]">
                  Select Recipients(s)
                </label>

                {/* Search Input */}
                <div
                  className={`mt-2 relative flex items-center bg-[#F4F4F4] rounded-lg px-3 py-2 w-full border ${
                    showError
                      ? "border-red-600 mb-1"
                      : "border-transparent mb-6"
                  }`}
                >
                  {/* Search icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="text-gray-500"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.08273 1.59739e-08C5.95323 9.62431e-05 4.84012 0.270304 3.83628 0.788078C2.83244 1.30585 1.96698 2.05618 1.31209 2.97646C0.657214 3.89674 0.231906 4.96029 0.0716544 6.07837C-0.088597 7.19645 0.0208552 8.33664 0.390879 9.40382C0.760904 10.471 1.38077 11.4342 2.19876 12.2131C3.01675 12.992 4.00915 13.564 5.09316 13.8813C6.17717 14.1987 7.32135 14.2522 8.43025 14.0374C9.53915 13.8227 10.5806 13.3458 11.4677 12.6467L14.5111 15.69C14.6682 15.8418 14.8787 15.9258 15.0972 15.9239C15.3157 15.922 15.5247 15.8344 15.6792 15.6798C15.8338 15.5253 15.9214 15.3163 15.9233 15.0978C15.9252 14.8793 15.8412 14.6688 15.6894 14.5117L12.6461 11.4683C13.4694 10.4238 13.982 9.16867 14.1253 7.84644C14.2686 6.52421 14.0367 5.18835 13.4563 3.99174C12.8758 2.79514 11.9701 1.78613 10.843 1.08019C9.71583 0.374255 8.4127 -8.92861e-05 7.08273 1.59739e-08ZM1.66606 7.08333C1.66606 5.64674 2.23675 4.26899 3.25257 3.25317C4.26839 2.23735 5.64614 1.66667 7.08273 1.66667C8.51932 1.66667 9.89707 2.23735 10.9129 3.25317C11.9287 4.26899 12.4994 5.64674 12.4994 7.08333C12.4994 8.51992 11.9287 9.89767 10.9129 10.9135C9.89707 11.9293 8.51932 12.5 7.08273 12.5C5.64614 12.5 4.26839 11.9293 3.25257 10.9135C2.23675 9.89767 1.66606 8.51992 1.66606 7.08333Z"
                      fill="#7B7B7B"
                    />
                  </svg>

                  {/* Input field */}
                  <input
                    type="text"
                    placeholder="Search suppliers"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="flex-1 bg-transparent border-0 outline-none focus:outline-none ml-2"
                  />
                </div>

                {showError && (
                  <p className="text-red-500 text-sm mt-2 mb-6 flex justify-start items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="mr-2"
                    >
                      <path
                        d="M12 4.705L11.295 4L8.5 6.795L5.705 4L5 4.705L7.795 7.5L5 10.295L5.705 11L8.5 8.205L11.295 11L12 10.295L9.205 7.5L12 4.705Z"
                        fill="#EB1004"
                      />
                    </svg>
                    You must choose a recipient
                  </p>
                )}

                {/* Supplier List */}
                <div className="mt-3 border rounded-lg overflow-hidden max-h-64 overflow-y-auto">
                  {filteredSuppliers.length > 0 ? (
                    filteredSuppliers.map((s) => (
                      <div
                        key={s._id}
                        className="flex items-center gap-3 px-4 py-2 cursor-pointer"
                        // onClick={() => toggleRecipient(s._id)}
                      >
                        <input
                          type="checkbox"
                          checked={selectedRecipients.some(
                            (r) => r._id === s._id
                          )}
                          onChange={(e) => {
                            e.stopPropagation();
                            toggleRecipient(s);
                          }}
                        />

                        <div className="flex items-center gap-3">
                          <div>
                            <CompanyAvatar
                              companyName={`${s?.contact?.type?.[0]?.name?.firstName} ${s?.contact?.type?.[0]?.name?.lastName}`}
                              size="36px"
                            />
                          </div>

                          <div className="flex flex-col">
                            <span className="font-medium text-gray-800">
                              {s?.contact?.type?.[0]?.name?.firstName}{" "}
                              {s?.contact?.type?.[0]?.name?.lastName}
                            </span>
                            <span className="text-sm text-gray-500">
                              {s?.company?.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-400 text-sm text-center py-3">
                      No suppliers found
                    </p>
                  )}
                </div>

                {/* Selected suppliers (row view) */}
                {selectedRecipients.length > 0 && (
                  <div className="flex flex-wrap gap-4 mt-4">
                    {suppliers
                      .filter((s) => selectedRecipients.includes(s._id))
                      .map((s) => (
                        <div className="flex items-center gap-3">
                          <div>
                            <CompanyAvatar
                              companyName={`${s?.contact?.type?.[0]?.name?.firstName} ${s?.contact?.type?.[0]?.name?.lastName}`}
                              size="36px"
                            />
                          </div>

                          <div className="flex flex-col">
                            <span className="font-medium text-gray-800">
                              {s?.contact?.type?.[0]?.name?.firstName}{" "}
                              {s?.contact?.type?.[0]?.name?.lastName}
                            </span>
                            <span className="text-sm text-gray-500">
                              {s?.company?.name}
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

                {/* Next button */}
                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      setSelectedRecipients([]);
                      setMessageInput("");
                      setBulkSubject("");
                    }}
                    className="px-4 py-2 bg-[#F1F1F1] rounded "
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      if (selectedRecipients.length === 0) {
                        setShowError(true);
                      } else {
                        setShowError(false);
                        setStep(2);
                      }
                    }}
                    className="bg-[#EBFF33] text-black font-medium px-5 py-2 rounded-md hover:opacity-90 disabled:opacity-60"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <div className="flex items-center gap-2 mb-3">
                  {selectedRecipients.length > 0 && (
                    <div className="flex flex-wrap gap-4 mt-4">
                      {suppliers
                        .filter((s) => selectedRecipients.includes(s._id))
                        .map((s) => (
                          <div className="flex items-center gap-3">
                            <div>
                              <CompanyAvatar
                                companyName={`${s?.contact?.type?.[0]?.name?.firstName} ${s?.contact?.type?.[0]?.name?.lastName}`}
                                size="36px"
                              />
                            </div>

                            <div className="flex flex-col">
                              <span className="font-medium text-gray-800">
                                {s?.contact?.type?.[0]?.name?.firstName}{" "}
                                {s?.contact?.type?.[0]?.name?.lastName}
                              </span>
                              <span className="text-sm text-gray-500">
                                {s?.company?.name}
                              </span>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
                {selectedRecipients.length > 1 && (
                  <div className="mb-3 mt-6">
                    <label className="text-base font-medium text-[#1D2739]">
                      Message Subject <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      value={bulkSubject}
                      onChange={(e) => {
                        setSubjectErr(false);
                        setBulkSubject(e.target.value);
                      }}
                      className={`mt-2 w-full bg-[#F4F4F4] rounded-lg px-3 py-2 ${
                        showSubjectErr
                          ? "border border-red-600 mb-1"
                          : "border border-transparent mb-6"
                      } focus:outline-none focus:border-gray-500`}
                    />

                    {showSubjectErr && (
                      <p className="text-red-500 text-sm mt-2 mb-6 flex justify-start items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          className="mr-2"
                        >
                          <path
                            d="M12 4.705L11.295 4L8.5 6.795L5.705 4L5 4.705L7.795 7.5L5 10.295L5.705 11L8.5 8.205L11.295 11L12 10.295L9.205 7.5L12 4.705Z"
                            fill="#EB1004"
                          />
                        </svg>
                        Message must have a subject
                      </p>
                    )}
                  </div>
                )}
                <label className="mb-2 text-base mt-6">Message</label>
                <div className="border border-[#B2B2B2] rounded-lg mt-2">
                  {/* <textarea
                    placeholder="Type your message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full h-32 p-3 text-sm resize-none mt-1 focus:outline-none"
                  /> */}

                  <div className="mb-2 gap-2 flex flex-col justify-start py-2 px-4">
                    {isImported && importedFile && (
                      <span className="ml-2 text-sm text-gray-600">
                        {importedFile.name}
                      </span>
                    )}

                    <textarea
                      placeholder="Type message"
                      rows="3"
                      className="flex-1 text-[#929292] resize-none p-2 border rounded-md focus:outline-none"
                      value={messageInput}
                      onChange={(e) => {
                        if (e.target.value.length <= MAX_LENGTH) {
                          setMessageInput(e.target.value);
                        }
                      }}
                      onKeyDown={(e) =>
                        e.key === "Enter" && handleSendMessage()
                      }
                    />
                    {attachedImage && (
                      <div className="m-1 relative w-10 h-10">
                        <img
                          src={
                            attachedImage instanceof File
                              ? URL.createObjectURL(attachedImage)
                              : attachedImage
                          }
                          alt="preview"
                          className="w-full h-full object-cover rounded-md"
                        />
                        <button
                          type="button"
                          className="absolute -top-3 -right-2 p-1 text-gray-400"
                          onClick={() => setAttachedImage(null)}
                        >
                          ✕
                        </button>
                      </div>
                    )}

                    <div className="flex justify-between items-center">
                      <div className="flex flex-row gap-2">
                        <input
                          type="file"
                          accept="image/*"
                          ref={imageInputRef}
                          className="hidden"
                          onChange={handleImageChange}
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="flex items-center justify-center cursor-pointer"
                          onClick={handleAttachImgClick}
                        >
                          <path
                            d="M7.86716 14.3868L13.7007 8.55333C14.4327 7.82133 15.4872 7.68858 16.2199 8.42058C16.9519 9.15258 16.8199 10.2078 16.0872 10.9398L9.98816 17.0388C8.92766 18.0993 6.80591 18.0993 5.48066 16.7733C4.15466 15.4473 4.15466 13.3263 5.21516 12.2658L11.3142 6.16683C12.2312 5.26647 13.4667 4.76465 14.7519 4.77056C16.037 4.77646 17.2679 5.28961 18.1766 6.19836C19.0854 7.10711 19.5985 8.33795 19.6044 9.62311C19.6103 10.9083 19.1085 12.1438 18.2082 13.0608L14.7612 16.5078"
                            stroke="#7B7B7B"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <EmojiPicker
                          onSelect={(emoji) =>
                            setMessageInput((prev) => prev + emoji)
                          }
                        />

                        <input
                          type="file"
                          ref={fileInputRef}
                          className="hidden"
                          onChange={handleFileChange}
                        />

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="flex items-center justify-center cursor-pointer"
                          onClick={handleAttachFileClick}
                        >
                          <path
                            d="M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z"
                            fill="#7B7B7B"
                          />
                        </svg>
                      </div>

                      <span className="text-[#B2B2B2]">
                        {messageInput.length}/{MAX_LENGTH}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end mt-4 gap-3">
                  <button
                    onClick={() => setStep(1)}
                    className="px-5 py-2 border rounded-md text-gray-600 hover:bg-gray-100"
                  >
                    Back
                  </button>
                  <button
                    onClick={() => {
                      if (selectedRecipients.length > 1 && bulkSubject === "") {
                        setSubjectErr(true);
                      } else if (
                        selectedRecipients.length > 1 &&
                        bulkSubject !== ""
                      ) {
                        handleSendBulkMessage();
                      } else {
                        handleSendMessageToNewUser();
                      }
                    }}
                    // disabled={!message.trim()}
                    className="bg-[#EBFF33] text-black font-medium px-5 py-2 rounded-md hover:opacity-90 disabled:opacity-60"
                  >
                    Create Message
                  </button>
                </div>
              </>
            )}
            {step === 3 && (
              <div className="flex justify-center">
                <button
                  onClick={() => {
                    setIsOpen(false);
                    setStep(1);
                    setSelectedRecipients([]);
                    setMessageInput("");
                    setBulkSubject("");
                  }}
                  className="px-6 py-2 bg-[#EAF524] text-black font-medium rounded mt-4 mb-4"
                >
                  OK
                </button>
              </div>
            )}
          </Dialog.Panel>
        </div>
      </Dialog>
      {userDetails}
    </div>
  );
};

export default Messages;
